import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'
import type { FileMetadata } from './events/events'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ManualColumnSelectionModal = lazy(() => import('./ManualColumnSelectionModal'))

class ManualColumnSelectionModalComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['project-id', 'file-metadata', 'multiple-files']
	}

	override render() {
		const projectId = this.prop('project-id')
		const fileMetadata = this.jsonProp<FileMetadata>('file-metadata')
		const multipleFiles = this.prop('multiple-files') === 'true'

		if (!fileMetadata) return null

		return (
			<AppProviders>
				<ManualColumnSelectionModal
					projectId={projectId}
					fileMetadata={fileMetadata}
					multipleFiles={multipleFiles}
				/>
			</AppProviders>
		)
	}
}

customElements.define('manual-column-selection-modal', ManualColumnSelectionModalComponent)
